import React from "react";
import { Button, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function DistrictFacilities({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <Table bordered>
          <thead>
            <tr className="table-secondary text-center align-middle">
              <th>Description</th>
              <th>TI</th>
              <th>LWS</th>
              <th>OST center</th>
              <th>Prisons </th>
              <th>OCS</th>
              <th>One Stop Centre </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Number of facilities</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total Target</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Number of facilities which have submitted monthly report </td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Percentage of facility reports received</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total No of Staff</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>No of vacant positions</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total No. of staff not attended any training</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Issue related to SOCH reporting</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>
          </tbody>
        </Table>

        <Table bordered>
          <thead>
            <tr className="table-secondary text-center align-middle">
              <th>Description</th>
              <th>ICTC </th>
              <th>SSK </th>
              <th>DSRC </th>
              <th>ART Centre</th>
              <th>Link ART Centre</th>
              <th>VL lab</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Number of facilities</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Number of facilities which have submitted monthly report </td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Percentage of facility reports received</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total No of Staff</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>No of vacant positions</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Total No. of staff not attended any training</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>

            <tr>
              <td>Issue related to SOCH reporting</td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
              <td><input type="text" className="text-center" placeholder="Please Enter"/></td>
            </tr>
          </tbody>
        </Table>
      </div>


      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
